import { Injectable } from '@angular/core';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { Router } from '@angular/router';
import { AuthService } from '../../auth';
import {
  CategoryDescriptionActionToggleLoading,
  CategoryDescriptionActionTypes,
  CategoryDescriptionDeleted,
  CategoryDescriptionOnServerDeleted,
  CategoryDescriptionPageLoaded,
  CategoryDescriptionPageRequested,
  CategoryDescriptionPageToggleLoading,
  FireCategoryDescriptionSuccess,
  ThrowCategoryDescriptionError,
} from '../_actions/category-description.actions';
import { CategoryDescriptionService } from '../_services/category-description.service';

@Injectable()
export class CategoryDescriptionEffects {
  showPageLoadingDistpatcher = new CategoryDescriptionPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new CategoryDescriptionPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new CategoryDescriptionActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new CategoryDescriptionActionToggleLoading({ isLoading: false });

  @Effect()
  loadCategoryDescriptionPage$ = this.actions$.pipe(
    ofType<CategoryDescriptionPageRequested>(
      CategoryDescriptionActionTypes.CategoryDescriptionPageRequested,
    ),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      return this.categoryDescription.findCategoryDescription(payload.page).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((result) => {
          return new CategoryDescriptionPageLoaded({
            categoryDescription: result.data,
            totalCount: result.count,
            page: result.page,
          });
        }),
      );
    }),
  );

  @Effect()
  deleteCategoryDescription$ = this.actions$.pipe(
    ofType<CategoryDescriptionOnServerDeleted>(
      CategoryDescriptionActionTypes.CategoryDescriptionOnServerDeleted,
    ),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.categoryDescription.deleteCategoryDescription(payload.id).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res && res.error) {
            return new ThrowCategoryDescriptionError({ error: res.error });
          } else {
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            this.store.dispatch(
              new FireCategoryDescriptionSuccess({
                action_type: CategoryDescriptionActionTypes.CategoryDescriptionDeleted,
              }),
            );
            return new CategoryDescriptionDeleted(payload);
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private categoryDescription: CategoryDescriptionService,
    private store: Store<AppState>,
    private router: Router,
    private authService: AuthService,
  ) {}
}
